import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSelectedTeamNumericId } from 'shared/utils/selectedTeamId';
import UserProfileDrawer from 'features/users/UserProfileDrawer';
import { OPEN_USER_PROFILE } from 'features/users/openUserProfile';

/**
 * The one place the user drawer lives. Mounted once in the Dashboard shell,
 * after the page, so it opens over whatever page or drawer asked for it.
 */
export default function UserProfileHost() {
  const params = useParams();
  const [distinctId, setDistinctId] = useState(null);

  useEffect(() => {
    const onOpen = (e) => setDistinctId(e?.detail?.distinctId || null);
    window.addEventListener(OPEN_USER_PROFILE, onOpen);
    return () => window.removeEventListener(OPEN_USER_PROFILE, onOpen);
  }, []);

  // A different team is a different set of users.
  useEffect(() => { setDistinctId(null); }, [params.team]);

  const close = useCallback(() => setDistinctId(null), []);
  if (!distinctId) return null;
  return (
    <UserProfileDrawer
      distinctId={distinctId}
      teamId={getSelectedTeamNumericId()}
      teamSlug={params.team}
      onClose={close}
    />
  );
}
